import React from "react";
import { Typography, TextField, InputAdornment, IconButton, Button, Switch } from "@material-ui/core";
import "../../styles/custom/forms/LoginForm.css";
import Instagram from "@material-ui/icons/Instagram";
import LinkedIn from "@material-ui/icons/LinkedIn";
import YouTube from "@material-ui/icons/YouTube";
import NightsStayOutlined from "@material-ui/icons/NightsStayOutlined";
import { ModoTemaContext } from "../../styles/theme/modoTema";
import logo from "../../styles/images/concilia-solucoes/conciliador/logo-conciliador-branca-nova.png";
import iconeUsuario from "../../styles/images/login/user.png";
import iconeSenha from "../../styles/images/login/password.png";
import iconeMostrarSenha from "../../styles/images/login/eye.png";
import iconeOcultarSenha from "../../styles/images/login/eye-crossed.png";

const REDES_SOCIAIS = [
    { nome: "Instagram", icone: <Instagram />, endereco: "https://www.instagram.com/somosconcilia" },
    { nome: "LinkedIn", icone: <LinkedIn />, endereco: "https://www.linkedin.com/company/somosconcilia/" },
    { nome: "YouTube", icone: <YouTube />, endereco: "https://www.youtube.com/@somosconcilia" }
];

type Props = {
  handleSubmit: (event: React.FormEvent<HTMLFormElement>) => void;
  classes: any;
  change: (event: React.FormEvent<HTMLInputElement>) => void;
  valueRecaptcha: string | null;
  showPassword: boolean;
  handleClickShowPassword: () => void;
  handleMouseDownPassword: (event: any) => void;
  loading: boolean;
  openEsqueciMinhaSenha: () => void;
  setLoginRef: (ref: any) => void;
};

const LoginConcilia: React.FC<Props> = ({
                                            handleSubmit,
                                            classes,
                                            change,
                                            showPassword,
                                            handleClickShowPassword,
                                            handleMouseDownPassword,
                                            loading,
                                            openEsqueciMinhaSenha,
                                            setLoginRef,
                                        }) => {
    const { modo, alternarModo } = React.useContext(ModoTemaContext);
    return (
        <div className={classes.conciliaShell}>
            <div className={classes.conciliaMain}>
                <section className={classes.conciliaPainelForm}>
                    <label className={classes.conciliaModoTema}>
                        <NightsStayOutlined fontSize="small" />
                        <span className={classes.conciliaModoTemaTexto}>Tema escuro</span>
                        <Switch
                            size="small"
                            color="primary"
                            checked={modo === "dark"}
                            onChange={alternarModo}
                            inputProps={{ role: "switch", "aria-label": "Tema escuro" }}
                        />
                    </label>
                    <div className={classes.conciliaFormBox}>
                        <Typography variant="h4" className={classes.conciliaTitulo}>
                            Bem-vindo de volta
                        </Typography>
                        <Typography className={classes.conciliaSubtitulo}>
                            Entre com seus dados para acessar o sistema.
                        </Typography>

                        <form onSubmit={handleSubmit}>
                            <div className={classes.conciliaFieldWrap}>
                                <Typography component="label" htmlFor="login-usuario" className={classes.conciliaLabel}>
                                    Usuário
                                </Typography>
                                <TextField
                                    inputRef={(ref) => setLoginRef(ref)}
                                    onChange={(e: any) => change(e)}
                                    autoFocus
                                    variant="outlined"
                                    id="login-usuario"
                                    name="username"
                                    placeholder="Digite seu usuário"
                                    required
                                    inputProps={{
                                        style: { textTransform: "uppercase" },
                                        maxLength: 50,
                                        autoComplete: "username",
                                    }}
                                    InputProps={{
                                        startAdornment: (
                                            <InputAdornment position="start">
                                                <img src={iconeUsuario} alt="" className={classes.conciliaFieldIcon} />
                                            </InputAdornment>
                                        ),
                                    }}
                                    className={classes.conciliaField}
                                />
                            </div>

                            <div className={classes.conciliaFieldWrap}>
                                <Typography component="label" htmlFor="login-senha" className={classes.conciliaLabel}>
                                    Senha
                                </Typography>
                                <TextField
                                    onChange={(e: any) => change(e)}
                                    variant="outlined"
                                    id="login-senha"
                                    name="password"
                                    type={showPassword ? "text" : "password"}
                                    placeholder="Digite sua senha"
                                    required
                                    inputProps={{ maxLength: 50, autoComplete: "current-password" }}
                                    InputProps={{
                                        startAdornment: (
                                            <InputAdornment position="start">
                                                <img src={iconeSenha} alt="" className={classes.conciliaFieldIcon} />
                                            </InputAdornment>
                                        ),
                                        endAdornment: (
                                            <InputAdornment position="end">
                                                <IconButton
                                                    aria-label={showPassword ? "Ocultar senha" : "Mostrar senha"}
                                                    onClick={handleClickShowPassword}
                                                    onMouseDown={handleMouseDownPassword}
                                                    style={{ padding: 6 }}
                                                >
                                                    <img src={showPassword ? iconeOcultarSenha : iconeMostrarSenha} alt="" className={classes.conciliaFieldIcon} />
                                                </IconButton>
                                            </InputAdornment>
                                        ),
                                    }}
                                    className={classes.conciliaField}
                                />
                            </div>

                            <div className={classes.conciliaOpt}>
                                <Button onClick={openEsqueciMinhaSenha} className={classes.conciliaLink}>
                                    Esqueceu a senha?
                                </Button>
                            </div>

                            <Button
                                variant="contained"
                                size="large"
                                type="submit"
                                disabled={loading}
                                className={classes.conciliaEnter}
                            >
                                Entrar
                            </Button>
                        </form>
                    </div>
                </section>

                <aside className={classes.conciliaPainelArte}>
                    <img
                        src={logo}
                        title={`${process.env.REACT_APP_VERSION}`}
                        alt="Conciliador"
                        className={classes.conciliaArteLogo}
                    />
                    <Typography component="div" className={classes.conciliaArteSlogan}>
                        <div>
                            Dados <b>confiáveis</b>.
                        </div>
                        <div>
                            Decisões <b>inteligentes</b>.
                        </div>
                    </Typography>
                </aside>
            </div>

            <footer className={classes.conciliaFooter}>
                <Typography className={classes.conciliaFooterMarca}>Concilia</Typography>
                <div className={classes.conciliaFooterRedes}>
                    <Typography className={classes.conciliaFooterRedesTitulo}>Acompanhe nossas redes</Typography>
                    {REDES_SOCIAIS.map((rede) => (
                        <a
                            key={rede.nome}
                            href={rede.endereco}
                            target="_blank"
                            rel="noopener noreferrer"
                            className={classes.conciliaFooterRede}
                        >
                            {rede.icone}
                            <span>{rede.nome}</span>
                        </a>
                    ))}
                </div>
            </footer>
        </div>
    );
};

export default LoginConcilia;
